module.exports = __webpack_public_path__ + "img/kvitto.e5a4a962.png";